import React from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button,TextField, Box} from '@mui/material'
import {StatementService} from '../../../services';
import CustomDataGrid  from '../../../customUtil/DataGrid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';

// const StyledDataGrid = withStyles({
//     root: {
//         '& .MuiDataGrid-renderingZone': {
//             maxHeight: 'none !important',
//         },
//         '& .MuiDataGrid-cell': {
//             lineHeight: 'unset !important',
//             maxHeight: 'none !important',
//             whiteSpace: 'normal',
//         },
//         '& .MuiDataGrid-row': {
//             maxHeight: 'none !important',
//         },
//         virtualScrollerContent: {
//             height: '100% !important',
//             overflow: 'scroll'
//         },
//     },
// })(DataGrid);

const Statements = () => {
        const [list, setList] = React.useState([]);
        const initialValue = {sections: ''};
        const [options, setOptions] = React.useState([]);
        const filterParams = [];
        const [tempRow, setTempRow] = React.useState([]);
        const history = useHistory();
        const code = localStorage.getItem('code');
        const savedFilters = JSON.parse(localStorage.getItem("St"));
        const [selected, setSelected] = React.useState(savedFilters ? savedFilters : initialValue);
        const [searchParam, setSearchParam] = React.useState(JSON.parse(localStorage.getItem("StSearch"))? JSON.parse(localStorage.getItem("StSearch")) : '');  
        const [rowList,  setRowList] = React.useState([]);

        const columns = [
            {
                field: 'title', headerName: 'Title',  minWidth: 230,
                renderCell: (params) => (
                    <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/templates/statement/' + params.row.id}>
                        {params.value}
                    </Link>
                )
            },
            {
                field: 'sectionTitle', headerName: 'Section', minWidth: 230
            },
            {
                field: 'content', headerName: 'Content', minWidth: 730, renderCell: (params) => (
                    <div style={{verticalALign: ' top',  lineHeight: 'unset !important'}}
                        dangerouslySetInnerHTML={{__html:(params.value === null? "" : params.value.substring(0,120) + '...')}}></div>
                )
            }
        ]

        React.useEffect(() => {
            StatementService.getById('options')
            .then((response) => {
                setOptions(response.data);
            });
            StatementService.getList()
                .then((response) => {
                    setList(response.data);
                    setTempRow(response.data);          
                    if(savedFilters){
                        setSelected(JSON.parse(localStorage.getItem("St")));
                      }  else{
                        setSelected(initialValue)
                      }
                });
              
        }, []);

           const handleChange = (param, e) => {
            setSelected({
            ...selected, 
            [param]: e.target.value})
      } 

      const detectChange = (e) => {
        setSearchParam(e.target.value);
       // searchKey(e.target.value);
         }
       
      React.useEffect(() => {
      filterList();
      localStorage.setItem('St', JSON.stringify(selected));
      localStorage.setItem('code', 'St');
      },[selected])

      React.useEffect(() => {
        localStorage.setItem('StSearch', JSON.stringify(searchParam));
       // if(searchParam !== ''){
          searchKey(searchParam);
      //  }
      },[rowList, searchParam]);    

      const searchKey = (e) => {
        let tempList = [];
        const filterBUffer = []; 
        rowList.forEach((filteredList) => {                    
       if(filteredList?.title.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
        }else if(filteredList?.sectionTitle?.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
        }else if(filteredList.content?.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
        }       
         tempList = filterBUffer
       })          
       setList(tempList)
      }

      const filterList = () => {   
        selected.sections !== '' && filterParams.push({'sectionTitle' : selected.sections})       
         let tempList = tempRow;
        filterParams.forEach(parent => {
            const filterBUffer = [] ;    
           tempList.forEach(el => {             
             Object.entries(el).map(key => {
                let parentKey = Object.keys(parent)
                let parentValue = Object.values(parent)
                if(key[0] === parentKey.toString()){
                    if(key[1] === parentValue[0]){
                        filterBUffer.push(el);
                    }
                }
             })               
             })
             tempList = filterBUffer;              
        });
                setRowList(tempList);
                setList(tempList)                  
    }
    
    const clearFilter = () => {
        setSelected(initialValue)
        localStorage.removeItem('St')
       }

    const handleSubmit = (event) => {
        event.preventDefault();
        filterList();
      };

        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Statements</h1>
                    </header>                    
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Button variant='contained' color='primary' component={RouterLink} to='/templates/statements/new'>Create New</Button>
                            </Grid>
                            <Grid item xs={12}>
                            <form onSubmit={handleSubmit}>
                            <Grid container spacing={4}>
                                <Grid item xs={5}>
                                <FormControl sx={{ m: 1, minWidth: 250 }}>
                           <InputLabel>Section</InputLabel>
                           <Select value={selected.sections} onChange={(e) => handleChange('sections', e)}
                          endAdornment={
                            selected.sections !== '' ? (
                                <IconButton sx={{visibility: selected.sections !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 sections: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {options?.map((el) => (
                      <MenuItem    value={el.name}>
                      {el.name}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                         <Button style={{marginTop: "10px"}} variant="contained" color="primary" onClick={clearFilter}>Clear Filter</Button>
                                </Grid> 
                            </Grid>
                            </form>
                            </Grid>
                            <Grid item xs={12}>
                            <Box
                            component="form"
                            sx={{'& > :not(style)': { m: 1, width: '25ch' }}}
                           // style={{float: "right"}}
                            noValidate
                            autoComplete="on"
                          >   
                          <TextField type="text" defaultValue={searchParam} label="Search" variant="standard" onChange={detectChange}  />
                         </Box>
                     
                            <Grid item xs={12}>
                            
                                <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={60}
                                showQuickFilter={true}
                               />
                               </Grid>
                            </Grid>
                        </Grid>                        
                </Container>
            </React.Fragment>
        );
    }
;

export default Statements;
